<ni-screen-ui-locker></ni-screen-ui-locker>
<div class="ndp-page">
  <ndp-page-header></ndp-page-header>
  <router-outlet></router-outlet>
</div>
<ni-toast-overlay-container></ni-toast-overlay-container>
